import type {
  ActionResourceAvailability,
  DirectoryFlags,
  ResourceKind,
} from "../types";

/**
 * Which directories are offerable for one action: the enterprise has to have the
 * directory enabled *and* the action has to actually have something in it, or
 * the menu would open onto an empty panel.
 */
export function availableKinds(
  directories: DirectoryFlags,
  availability: ActionResourceAvailability,
): ResourceKind[] {
  const kinds: ResourceKind[] = [];
  if (directories.expert_directory_enabled && availability.has_public_experts) {
    kinds.push("expert");
  }
  if (directories.tool_directory_enabled && availability.has_tools) {
    kinds.push("tool");
  }
  if (
    directories.financial_aid_directory_enabled &&
    availability.has_financial_aids
  ) {
    kinds.push("financialAid");
  }
  return kinds;
}

/** True when the action has at least one offerable directory. */
export function hasAnyResource(
  directories: DirectoryFlags,
  availability: ActionResourceAvailability,
): boolean {
  return availableKinds(directories, availability).length > 0;
}
